/**
 * Плагин страницы билетов в профиле.
 *
 * @return {jQuery}
 */
(function ($) {
    'use strict';

    $.fn.profileTickets = function()
    {
        const $container = $(this);

        const eventNamespace = '.profileTickets';
        const hiddenClass = 'visually-hidden';

        const $loader = $container.find('.js-loader-wrapper');
        const $emptyList = $container.find('.js-empty-list');
        const $orderList = $container.find('.js-list');
        const $qrCodePopup = $container.find('.js-qr-code-popup');
        const $qrCode = $container.find('.js-qr-code');
        const $returnPopup = $container.find('.js-return-popup');
        const purchaseType = $container.data('purchase-type') || 'ticket';

        let $infoToggleButton = null;
        let $pagerButton = null;
        let $payOrderButton = null;
        let $cancelOrderButton = null;
        let $showQRCodeButton = null;
        let $showReturnPopupButton = document.querySelector('[data-return-open]');
        let $sendEmailButton = null;
        let $seasonActionButton = null;
        let $seasonSubmitButton = null;

        /**
         * Инициализация плагина.
         */
        const init = function()
        {
            $qrCodePopup.find('.js-close-qr-code-popup').on('click', hideQRCode);
            $returnPopup.find('.js-close-return-popup').on('click', hideReturnPopup);

            showInitialLists();
        }

        /**
         * Инициализация кнопок постраничной навигации.
         */
        const initPagerButtons = function ()
        {
            if (($pagerButton !== null) && ($pagerButton.length > 0)) {
                $pagerButton.off('click' + eventNamespace);
            }

            $pagerButton = $orderList.find('.js-pager-btn');
            $pagerButton.on('click' + eventNamespace, showListNextPage);
        }

        /**
         * Инициализация кнопок "Развернуть" / "Свернуть".
         */
        const initInfoToggleButtons = function ()
        {
            if (($infoToggleButton !== null) && ($infoToggleButton.length > 0)) {
                $infoToggleButton.off('click' + eventNamespace);
            }

            $infoToggleButton = $orderList.find('.js-toggle-show-list');
            $infoToggleButton.on('click' + eventNamespace, toggleList);
        }

        /**
         * Инициализация кнопок оплаты заказа.
         */
        const initPayOrderButtons = function ()
        {
            if (($payOrderButton !== null) && ($payOrderButton.length > 0)) {
                $payOrderButton.off('click' + eventNamespace);
            }

            $payOrderButton = $orderList.find('.js-pay-order');
            $payOrderButton.on('click' + eventNamespace, goToPaymentPage);
        }

        /**
         * Инициализация кнопок отмены заказа.
         */
        const initCancelOrderButtons = function ()
        {
            if (($cancelOrderButton !== null) && ($cancelOrderButton.length > 0)) {
                $cancelOrderButton.off('click' + eventNamespace);
            }

            $cancelOrderButton = $orderList.find('.js-cancel-order');
            $cancelOrderButton.on('click' + eventNamespace, cancelOrder);
        }

        /**
         * Инициализация кнопок показа QR-кода.
         */
        const initShowQRCodeButtons = function ()
        {
            if (($showQRCodeButton !== null) && ($showQRCodeButton.length > 0)) {
                $showQRCodeButton.off('click' + eventNamespace);
            }

            $showQRCodeButton = $orderList.find('.js-show-qr-code');
            $showQRCodeButton.on('click' + eventNamespace, showQRCode);
        }

        /**
         * Инициализация кнопок возврата.
         */
        const initShowReturnPopupButtons = function ()
        {
            if (($showReturnPopupButton !== null) && ($showReturnPopupButton.length > 0)) {
                $showReturnPopupButton.off('click' + eventNamespace);
            }

            $showReturnPopupButton = $orderList.find('.js-show-return-popup');
            $showReturnPopupButton.on('click' + eventNamespace, showReturnPopup);
        }

        /**
         * Инициализация кнопок отправки билета на почту.
         */
        const initSendEmailButtons = function ()
        {
            if (($sendEmailButton !== null) && ($sendEmailButton.length > 0)) {
                $sendEmailButton.off('click' + eventNamespace);
            }

            $sendEmailButton = $orderList.find('.js-send-email');
            $sendEmailButton.on('click' + eventNamespace, sendTicketEmail);
        }

        /**
         * Подстановка данных матча в статические модальные окна абонемента.
         */
        const initSeasonActionButtons = function ()
        {
            if (($seasonActionButton !== null) && ($seasonActionButton.length > 0)) {
                $seasonActionButton.off('click' + eventNamespace);
            }

            $seasonActionButton = $orderList.find('.js-season-ticket-action');
            $seasonActionButton.on('click' + eventNamespace, prepareSeasonTicketModals);

            if (($seasonSubmitButton !== null) && ($seasonSubmitButton.length > 0)) {
                $seasonSubmitButton.off('click' + eventNamespace);
            }

            $seasonSubmitButton = $container.find('.season-ticket-modal-window [data-submit-button]');
            $seasonSubmitButton.on('click' + eventNamespace, submitSeasonTicketAction);
        }

        /**
         * Инициализация кнопок.
         */
        const initButtons = function ()
        {
            initInfoToggleButtons();
            initPagerButtons();
            initPayOrderButtons();
            initCancelOrderButtons();
            initShowQRCodeButtons();
            initShowReturnPopupButtons();
            initSendEmailButtons();
            initSeasonActionButtons();
        }

        /**
         * Первый показ списков при загрузке страницы.
         */
        const showInitialLists = function()
        {
            getTicketsList().done(function (response) {
                if (response.result === false) {
                    $emptyList.removeClass(hiddenClass);
                    return;
                }

                let $list;
                let $listPager;
                let $listPagerBtn;

                let listData;
                let $listItems;

                for (const listType in response.lists) {
                    $list = $orderList.filter('[data-list-type="' + listType + '"]');
                    if (!$list.length) {
                        continue;
                    }

                    listData = response.lists[listType];
                    if (listData.html === '') {
                        continue;
                    }

                    $listItems = $list.find('.js-items');

                    $listItems.html(listData.html);
                    $list.removeClass(hiddenClass);

                    $listPager = $list.find('.js-pager');
                    if (!$listPager.length) {
                        continue;
                    }

                    $listPagerBtn = $listPager.find('.js-pager-btn');

                    if ((listData.lastPage > 1) && (listData.currentPage < listData.lastPage)) {
                        $listPagerBtn.data('page', ++listData.currentPage);
                        $listPagerBtn.prop('disabled', false);
                        $listPager.removeClass(hiddenClass);
                    } else {
                        $listPagerBtn.data('page', null);
                        $listPagerBtn.prop('disabled', true);
                        $listPager.addClass(hiddenClass);
                    }
                }

                initButtons();
            });
        }

        /**
         * Показ следующей страницы списка.
         *
         * @param event
         */
        const showListNextPage = function (event)
        {
            event.preventDefault();

            const $listPagerBtn = $(this);
            const $list = $listPagerBtn.closest('.js-list');
            if (!$list.length) {
                return;
            }

            const $listPager = $list.find('.js-pager');

            const listType = $list.data('list-type');
            const nextPage = $listPagerBtn.data('page');
            const mode = $listPagerBtn.data('mode');

            let listData;
            let $listItems;

            getTicketsList(listType, nextPage).done(function (response) {
                if (response.result === false) {
                    return;
                }

                if (response.listType !== listType) {
                    return;
                }

                listData = response.lists[listType];

                $listItems = $list.find('.js-items');
                if (mode === 'append') {
                    $listItems.append(listData.html);
                } else {
                    $listItems.html(listData.html);
                }

                if ((listData.lastPage > 1) && (listData.currentPage < listData.lastPage)) {
                    $listPagerBtn.data('page', ++listData.currentPage);
                    $listPagerBtn.prop('disabled', false);
                    $listPager.removeClass(hiddenClass);
                } else {
                    $listPagerBtn.data('page', null);
                    $listPagerBtn.prop('disabled', true);
                    $listPager.addClass(hiddenClass);
                }

                initButtons();
            });
        }

        /**
         * Получение списка билетов.
         *
         * @returns {*}
         */
        const getTicketsList = function (listType = 'all', page = 1)
        {
            return $.ajax('/ajax/user/profile/get-tickets-list.php', {
                data: {
                    listType: listType,
                    page: page,
                    purchaseType: purchaseType
                }
            }).always(function () {
                $loader.addClass(hiddenClass);
            });
        }

        /**
         * Разворачивание / сворачивание списка билетов.
         */
        const toggleList = function ()
        {
            const $button = $(this);

            const $order = $button.closest('.js-order');
            const $shortList = $order.find('.js-short-list');
            const $detailList = $order.find('.js-detail-list');

            const mode = $order.hasClass('is-open') ? 'hide' : 'show';

            if (mode === 'hide') {
                if ($shortList.length > 0) {
                    $shortList.slideDown();
                }

                $detailList.slideUp();
            } else {
                if ($shortList.length > 0) {
                    $shortList.slideUp();
                }

                $detailList.slideDown();
            }

            $order.toggleClass('is-open');
            $button.attr('aria-expanded', mode === 'show' ? 'true' : 'false');
        }

        /**
         * Отправка существующего билета на email пользователя.
         */
        const sendTicketEmail = function (event)
        {
            event.preventDefault();

            const $button = $(this);
            const ticketId = $button.data('ticket-id');

            if (!ticketId) {
                return;
            }

            $button.prop('disabled', true);

            $.post('/ajax/user/profile/sendTicketEmail.php', {
                ticket_id: ticketId
            }).done(function (response) {
                if (response === 'true') {
                    alert('Билет отправлен на ваш email!');
                } else {
                    alert('Ошибка отправки');
                }
            }).fail(function () {
                alert('Ошибка соединения');
            }).always(function () {
                $button.prop('disabled', false);
            });
        }

        /**
         * Подстановка данных матча в модальные окна абонемента.
         */
        const prepareSeasonTicketModals = function ()
        {
            const $button = $(this);
            const $modals = $container.find('.season-ticket-modal-window');

            $modals.find('[data-season-modal-match]').text($button.data('match-name') || 'Матч');
            $modals.find('[data-season-modal-date]').text($button.data('match-date') || 'Дата уточняется');
            $modals.find('[data-season-modal-seat]').text($button.data('match-seat') || 'Место уточняется');
            $modals.find('[data-submit-checkbox]').prop('checked', false);
            $modals.find('[data-submit-button]').prop('disabled', true);

            // действие и матч запоминаются на кнопке подтверждения той модалки, которую открыли
            $container.find('#' + $button.data('open-modal')).find('[data-submit-button]')
                .data('action', $button.data('action'))
                .data('ticket-id', $button.data('ticket-id'))
                .data('calendar-id', $button.data('calendar-id'));
        }

        /**
         * Передача места другу или возврат его в продажу.
         */
        const submitSeasonTicketAction = function ()
        {
            const $button = $(this);

            const action = $button.data('action');
            const ticketId = parseInt($button.data('ticket-id'));
            const calendarId = parseInt($button.data('calendar-id'));

            if (!action || !ticketId || !calendarId) {
                return;
            }

            $button.prop('disabled', true);

            $.ajax('/ajax/user/profile/season-ticket-action.php', {
                method: 'POST',
                data: {
                    action: action,
                    ticketId: ticketId,
                    calendarId: calendarId
                }
            }).done(function (response) {
                if (response.result !== true) {
                    alert('Ошибка: ' + (response.message || 'Не удалось выполнить действие'));
                    $button.prop('disabled', false);
                    return;
                }

                if (response.link) {
                    showSeasonTicketSuccess(response.link);
                    return;
                }

                location.reload();
            }).fail(function () {
                alert('Ошибка соединения');
                $button.prop('disabled', false);
            });
        }

        /**
         * Показ билета для друга. Список статусов обновляется перезагрузкой после закрытия окна.
         */
        const showSeasonTicketSuccess = function (link)
        {
            const successModal = document.getElementById('season-ticket-success-modal');
            if (!successModal) {
                location.reload();
                return;
            }

            $container.find('.season-ticket-modal-window').each(function () {
                if (this !== successModal) {
                    this.close();
                }
            });

            $(successModal).find('[data-season-modal-pdf]').attr('href', link);
            successModal.addEventListener('close', function () {
                location.reload();
            }, {once: true});
            successModal.show();
        }

        /**
         * Переход к странице оплаты заказа.
         */
        const goToPaymentPage = function ()
        {
            const $button = $(this);
            const $order = $button.closest('.js-order');

            const orderId = parseInt($order.data('id'));

            $.ajax('/ajax/user/profile/get-order-payment-form.php', {
                method: 'POST',
                data: {
                    orderId: orderId
                }
            }).done(function (response) {
                if (response.hasOwnProperty('message') && (response.message !== null)) {
                    alert('Ошибка: ' + response.message);
                    return;
                }

                let $formWrapper = $order.find('.js-payment-form-wrapper');

                if ($formWrapper.length === 0) {
                    let $formWrapper = $('<div class="js-payment-form-wrapper visually-hidden">');
                    $formWrapper.html(response);
                    $order.append($formWrapper);
                } else {
                    $formWrapper.html(response);
                }

                const $paymentForm = $formWrapper.find('form');
                if ((typeof $paymentForm !== 'undefined') && ($paymentForm.length === 1)) {
                    $paymentForm.trigger('submit');
                }
            });
        }

        /**
         * Отмена заказа.
         */
        const cancelOrder = function ()
        {
            const $button = $(this);
            const $order = $button.closest('.js-order');
            const $statusText = $order.find('.js-order-status-text');

            const orderId = parseInt($order.data('id'));

            if (!confirm('Вы действительно хотите отменить заказ №' + orderId + '?')) {
                return;
            }

            $.ajax('/ajax/user/profile/cancel-order.php', {
                method: 'POST',
                data: {
                    orderId: orderId
                }
            }).done(function (response) {
                if (response.message !== null) {
                    alert('Ошибка: ' + response.message);
                    return;
                }

                const $cancelOrderButton = $order.find('.js-cancel-order');
                const $payOrderButton = $order.find('.js-pay-order');

                $cancelOrderButton.off(eventNamespace);
                $payOrderButton.off(eventNamespace);

                $cancelOrderButton.remove();
                $payOrderButton.remove();

                $statusText.text('Отменён');
                $statusText.addClass('is-canceled');

                alert('Заказ №' + orderId + ' успешно отменён.');
            });
        }

        /**
         * Показать QR-код.
         */
        const showQRCode = function ()
        {
            const $button = $(this);

            const canvas = $qrCode.get(0);
            const barcode = $button.data('barcode');

            canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);

            QRCode.toCanvas(canvas, barcode.toString(), {
                width: 200
            }, function (error) {
                if (error) {
                    console.error(error);
                    return;
                }

                $qrCodePopup.addClass('opened');
            });
        }

        /**
         * Скрыть QR-код.
         */
        const hideQRCode = function ()
        {
            $qrCodePopup.removeClass('opened');
        }

        /**
         * Показать попап возврата.
         */
        const showReturnPopup = function ()
        {
            $returnPopup.addClass('opened');
        }

        /**
         * Скрыть попап возврата.
         */
        const hideReturnPopup = function ()
        {
            $returnPopup.removeClass('opened');
        }

        init();

        return this;
    }
})(jQuery);
